(function($) {
  "use strict";
  $(function() {
    $(window).on("b24:form:init", function(event) {
      var form = event.detail.object;
      if (form.identification.id == 8) {
        window["requestProductForm"] = form;
      }
    });

    $(".requestProduct").click(function() {
      $(".hiddenRequestProduct").click();
      var product = $(this).attr("data-name");
      window["requestProductForm"].setValues({
        LEAD_COMMENTS: "Запрос цены на " + product + " в количестве ____ кг"
      });
    });
  });
})(jQuery);
